import { usePost, useDelete } from "@/api/lib/integration";
import type { UnregisterPushDevice, RegisterPushDevice } from "@/api/pushRegistration/types";

export const registerPushDevice = usePost<RegisterPushDevice, void>('/api/pushregistrations');
export const unregisterPushDevice = useDelete<UnregisterPushDevice, void>('/api/pushregistrations/{deviceToken}', { preventRedirect: true });
